import { Injectable } from '@angular/core';

import { ClaimDetailsService } from '@open-portal-app/core/services/claim-details.service';
import { ConfigService } from '@campfire-nx/api';
import { CLAIM_CONSTANTS } from '../constants/policy.constants';

@Injectable({
  providedIn: 'root'
})
export class PolicyClaimsService {
  constructor(
    private claimDetailsService: ClaimDetailsService,
    private configService: ConfigService
  ) { }

  updateClaimsList(policyClaims: any, claimStatus: keyof typeof CLAIM_CONSTANTS) {
    const claimsList: any = [];
    const status =  CLAIM_CONSTANTS[claimStatus];
    let claimDetails = {
      name: "",
      status: "",
      description: "",
      variant: ""
    }

    policyClaims.forEach((claim: any) => {
      if (Array.isArray(status) && status.includes(claim.state)) {
        claimDetails = this.getClaimDetails(claim);

        claimsList.push(
          {
            icon: PolicyClaimsService.getClaimIcon(claim.event_type, claim.product_type),
            name: claimDetails.name,
            description: claimDetails.description,
            status: claimDetails.status,
            variant: claimDetails.variant,
            linkType: 'claim',
            slug: claim.slug
          }
        )
      }
    })
    return claimsList;
  }

  static getClaimIcon(eventType: string, productType: string): string {
    const iconName = CLAIM_CONSTANTS.icons[eventType as keyof typeof CLAIM_CONSTANTS.icons] ||
           CLAIM_CONSTANTS.icons[productType as keyof typeof CLAIM_CONSTANTS.icons];

    return iconName;
  }

  getClaimDetails(claim: any) {
    const isTpaClaim = !!(claim?.tpa_partner && Object.keys(claim?.tpa_partner).length > 0);
    let claimType = '';
    let claimDetails = {
      name: "",
      status: "",
      description: "",
      variant: ""
    }

    if (isTpaClaim) {
      claimDetails = {
        name: claim?.tpa_claim_type,
        description: `Claim number: ${claim?.tpa_claim_id}`,
        status: this.claimDetailsService.getClaimStatus(isTpaClaim, isTpaClaim ? claim?.tpa_claim_status : claim?.state) as any,
        variant: this.claimDetailsService.getClaimStatusVariant(isTpaClaim ? claim?.tpa_claim_status : claim?.state) as any
      }
    } else {
      for (const [key, value] of Object.entries(this.configService.data.types.claimEventTypes) as [string, Record<string, any>][]) {
        if (value[claim.event_type]) {
          claimType = value[claim.event_type].label;
        }
      }

      claimDetails = {
        name: claimType,
        description: `Claim number: ${claim.claim_number}`,
        status: this.configService.data.types.claimStates[claim.state].customer.label,
        variant: claim.state
      }
    }

    return claimDetails;
  }
}
